import { CALL_API } from '../Middleware/API';

const APICall = ({ type, url, data = {}, query = {}, schema, params }) => {
    let endpoint = url;
    if (typeof url === 'function') {
        endpoint = url(params, query, data);
    }
    return {
        [CALL_API]: {
            types: ['API_REQUEST', 'API_SUCCESS', 'API_FAILURE'],
            endpoint,
            schema,
            query,
            options: {
                type: type,
                data: data
            }
        }
    };
};
export default APICall;
